import { connect } from 'react-redux';

import SortBy from '../SortBy/SortBy';

import { changeSortingOfPage } from '../../reduck/listingPagePages.reduck';

import { getActiveListingPage } from '../../reduck/selectors';

const searchLabsSortingToUrlSortingMap = {
  relevance: 'relevance-desc',
  brand_label: 'brand-asc',
  brand_label_desc: 'brand-desc',
  price: 'price-asc',
  price_desc: 'price-desc',
  average_score_desc: 'rating-desc',
  discount_desc: 'discount-desc'
};


const mapStateToProps = (state) => ({
  options: getActiveListingPage(state)
    .sortByOptions
    .items
    .map((item) => ({ label: item.label, id: item.value })),
  defaultOptionIndex: getActiveListingPage(state)
    .sortByOptions
    .items
    .findIndex((item) => item.selected),
  label: getActiveListingPage(state).sortByOptions.label,
  disabled: state.listingPage.commonData.xhrStatus.pendingProductsRequest

});

const mapDispatchToProps = (dispatch) => ({
  onSelectedItemChange: (selectedOption) => {
    dispatch(changeSortingOfPage(searchLabsSortingToUrlSortingMap[selectedOption.id]));
  }
});


export default connect(mapStateToProps, mapDispatchToProps)(SortBy);
